/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _MammographyEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import journalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import MammographyDeclaredJournalEvent from "core/models/mammography-declared-journal-event";
import SemeiaSessionService from "core/services/session";
import { IntlService } from "ember-intl";
let MammographyEditionFormComponent = (_class = (_MammographyEditionFormComponent = class MammographyEditionFormComponent extends journalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "examType", "acrScore", "comments"]);
  }
  get validations() {
    return this.journalEventClass.validations(this.intl);
  }
  retrieveModel() {
    const model = super.retrieveModel();
    model.occurredAt = model.occurredAt || new Date();
    model.examType = model.examType || "mri";
    return model;
  }
  get toastMessage() {
    return this.session.patient ? {
      message: "Votre déclaration a bien été prise en compte.",
      title: this.intl.t(`mammography-exam.type.${this.changeset.get("examType")}`)
    } : super.toastMessage;
  }
}, _defineProperty(_MammographyEditionFormComponent, "fullComponentId", "mammography-and-mri/edition-form"), _defineProperty(_MammographyEditionFormComponent, "journalEventClass", MammographyDeclaredJournalEvent), _defineProperty(_MammographyEditionFormComponent, "forcDisplayName", "Mammographie ou IRM"), _MammographyEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MammographyEditionFormComponent as default };